import React from 'react';

import { useSearchBox } from 'react-instantsearch-core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { Button } from '@uncinc/uncinc-react-kitchen-sink';

import { useMenu, useClearRefinements } from 'react-instantsearch';
import {
  SearchAutocomplete,
} from '@uncinc/react-searchkit';

import {
  resultAttributes,
  facetAttributes,
} from '../config';

import { APP_OPTIONS, SEARCHKIT_HOST_URL, SEARCH_PATH } from '../../../config/constants';

import './style.scss';

const SEARCH_AUTOSUGGEST_RESULTS = 5;
const SEARCH_AUTOCOMPLETE_RESULTS = 4;

const SearchBar = (props) => {
  const { t } = useTranslation();
  const history = useHistory();

  const {
    refine,
  } = useSearchBox(props);

  const requestTypeFacet = facetAttributes.filter((facetAttribute) => facetAttribute.field === 'field_request_type')[0];
  const {
    refine: refineFacet,
  } = useMenu(requestTypeFacet);

  const { refine: clearActiveFacets } = useClearRefinements(requestTypeFacet);
  const path = useSelector((state) => state.getIn(['router', 'location', 'pathname']));
  const initialAutocompleteQuery = useSelector((state) => state.getIn(['router', 'location', 'query', encodeURIComponent(`${APP_OPTIONS.parameters.searchkitIndexAlLProjects}[query]`)], ''));

  // Go to the search page with the query and request type values.
  const handleSubmit = (e, b) => {
    e.preventDefault();

    const suggestionRaw = e.target[0].value;
    const suggestion = suggestionRaw.charAt(0).toUpperCase() + suggestionRaw.slice(1);
    const requestTypeQueryValue = e.nativeEvent.submitter.dataset.target;

    if (path === SEARCH_PATH) {
      refine(suggestion);
      clearActiveFacets();
      refineFacet(requestTypeQueryValue);
    } else {
      const query = encodeURIComponent(`${APP_OPTIONS.parameters.searchkitIndexAlLProjects}[query]`);
      const requestTypeQuery = encodeURIComponent(`${APP_OPTIONS.parameters.searchkitIndexAlLProjects}[menu][field_request_type]`);

      const newPath = `${SEARCH_PATH}?${query}=${suggestion}&${requestTypeQuery}=${requestTypeQueryValue}`;

      history.push(newPath);
    }
  };

  return (
    <div className="SearchBar" id="SearchBar">
      <form onSubmit={handleSubmit}>
        <SearchAutocomplete
          connection={{ host: SEARCHKIT_HOST_URL }}
          indexName={APP_OPTIONS.parameters.searchkitIndexAlLProjects}
          resultAttributes={resultAttributes}
          autocompleteAttributes={['autocomplete_field']}
          autocompleteResults={SEARCH_AUTOCOMPLETE_RESULTS}
          autosuggestAttributes={['title']}
          autosuggestResults={SEARCH_AUTOSUGGEST_RESULTS}
          renderProps={{
            placeholder: t('maatjes_search.input_placeholder'),
            renderSuggestion: (suggestion) => {
              const suggestionTitle = suggestion.autocomplete_text[0];
              const label = suggestionTitle.charAt(0).toUpperCase() + suggestionTitle.slice(1);
              return (
                <div>{label}</div>
              );
            }
          }}
          searchSettings={{
            highlight_attributes: ['autocomplete_field', 'autocomplete_field_suggest'],
          }}
          initialUiState={{
            [APP_OPTIONS.parameters.searchkitIndexAlLProjects]: {
              query: decodeURI(initialAutocompleteQuery),
            },
          }}
        />
        <div className="SearchBar__actions">
          <Button type="submit" data-target="maatje_worden" className="Button icon-arrow-right icon-before icon-after moving-arrow">
            {t('maatjes.search.button_become_maatje')}
          </Button>
          <Button type="submit" data-target="maatje_zoeken" className="Button icon-arrow-right icon-before icon-after moving-arrow">
            {t('maatjes.search.button_search_maatje')}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default SearchBar;
